export default {
  getstarted: "/",
  template: "/template",
  guestlist: "/guestlist",
  order: "/order"
};
